import { z } from "zod";
import {
  baseFilterShape,
  teammateFilterShape
} from "./customerInteractionFilters.js";
const playbookStatsFiltersSchema = z.object({
  ...baseFilterShape,
  ...teammateFilterShape
}).nullish().describe(
  "Optional AND filters restricting which interactions the stats cover \u2014 the same filters count-customer-interactions takes, so run it with these filters first to check the volume behind the numbers. Omit for every interaction in the date range."
);
export {
  playbookStatsFiltersSchema
};
//# sourceMappingURL=playbookStatsFilters.js.map
